import { render, staticRenderFns } from "./Upwork.vue?vue&type=template&id=1455fc82"
import script from "./Upwork.vue?vue&type=script&lang=js"
export * from "./Upwork.vue?vue&type=script&lang=js"
import style0 from "./Upwork.vue?vue&type=style&index=0&id=1455fc82&prod&lang=css"
import style1 from "./Upwork.vue?vue&type=style&index=1&id=1455fc82&prod&lang=css"
import style2 from "./Upwork.vue?vue&type=style&index=2&id=1455fc82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports